import { render, staticRenderFns } from "./DashboardDestinos.vue?vue&type=template&id=842bbaf6"
import script from "./DashboardDestinos.vue?vue&type=script&lang=js"
export * from "./DashboardDestinos.vue?vue&type=script&lang=js"
import style0 from "./DashboardDestinos.vue?vue&type=style&index=0&id=842bbaf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports